EASY.schedule.main(function () {
  const $richMenuParent = $("#top-menu-rich-more").attr("data-widget-content", "#top-menu-rich-more-list");
  //var $richMenuAnchor = $richMenuParent.find(">a");
  //var $richMenuMenu = $richMenuParent.find(">ul.menu-children");
  const $topMenuContainer = $("#top-menu-container");
  const $topMenuNavigation = $("#top-menu-container-navigation");
  const $mobileTopMenuToggler = $("#mobile-top-menu-toggler");
  const $loggedAs = $("#loggedas");
  const $topMenuParents = $topMenuContainer.find(".with-easy-submenu");
  const menuBreakpoint = EASY.getSassData("media-collapse-menu", "960px");
  const mobileMenuMedia = window.matchMedia(`(max-width: ${menuBreakpoint})`);
  const portraitBreakpoint = EASY.getSassData("breakpoint-medium-portrait", "768px");
  const portraitMedia = window.matchMedia(`(max-width: ${portraitBreakpoint})`);

  function closeRichMenuOnOutsideClick(event) {
    if ($richMenuParent[0].contains(event.target)) return;
    // Below the portrait breakpoint the user menu sits inside the opened rich menu bar,
    // so a click on it must open the user menu, not close the whole rich menu.
    if (portraitMedia.matches && $loggedAs[0]?.contains(event.target)) return;

    $richMenuParent[0].click();
  }

  function focusRichMenuSearch() {
    requestAnimationFrame(function () {
      const searchInput = $richMenuParent[0]?.querySelector(
        '[data-cy="ds-base-input__input--rich-menu-search"]'
      );
      searchInput?.focus();
    });
  }

  // const $moreGroup = document.querySelector('.top-menu-rich-more-group');
  // if($moreGroup) {
  //   $moreGroup.style.overflowY = 'hidden';
  // };

  EASY.schedule.require(
    function () {
      $richMenuParent.toggleable({
        observer: EASY.defaultClickObserver,
        content: $(this).attr("data-widget-content"),
        ignore: $loggedAs,
        openCallback: function () {
          $("body").addClass("left-menu-opened");
          document.addEventListener("click", closeRichMenuOnOutsideClick, true);
          focusRichMenuSearch();
        },
        closeCallback: function () {
          $("body").removeClass("left-menu-opened");
          document.removeEventListener("click", closeRichMenuOnOutsideClick, true);
        },
      });
      $topMenuParents.each(function (index, parent) {
        const $parent = $(parent);
        const $trigger = $parent.find(".easy-top-menu-more-toggler");
        const $content = $parent.find(".easy-menu-children");
        $trigger.toggleable({
          observer: EASY.defaultClickObserver,
          content: $content,
          openCallback: function () {
            if (!mobileMenuMedia.matches) EASY.utils.expandMenuNoUserPref();
          },
        });
      });

      if (!$mobileTopMenuToggler.length || !$topMenuNavigation.length) return;

      $mobileTopMenuToggler.toggleable({
        observer: EASY.defaultClickObserver,
        content: $topMenuNavigation,
        openCallback: function () {
          $("body").addClass("mobile-top-menu-opened");
          $topMenuNavigation.find("a[href]")?.first()?.focus();
        },
        closeCallback: function () {
          $("body").removeClass("mobile-top-menu-opened");
        },
      });

      const closeMobileTopMenu = function () {
        const mobileTopMenu = $mobileTopMenuToggler.toggleable("instance");
        if (mobileTopMenu?.state) mobileTopMenu._close();
      };

      const closeMobileTopMenuOnEscape = function (event) {
        const mobileTopMenu = $mobileTopMenuToggler.toggleable("instance");
        if (event.key !== "Escape" || !mobileTopMenu?.state) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        closeMobileTopMenu();
        $mobileTopMenuToggler[0].focus({ focusVisible: true });
      };
      document.addEventListener("keydown", closeMobileTopMenuOnEscape, true);
      mobileMenuMedia.addEventListener("change", function (event) {
        if (event.matches) return;

        const mobileTogglerHadFocus = document.activeElement === $mobileTopMenuToggler[0];
        closeMobileTopMenu();
        if (mobileTogglerHadFocus) {
          const desktopFocusTarget =
            $topMenuNavigation.find("a:visible").first()[0] || document.querySelector("#logo a");
          desktopFocusTarget?.focus({ focusVisible: true });
        }
      });
    },
    function () {
      return EASY.defaultClickObserver;
    }
  );

  // Setup event listeners for elements inside #easy_servicebar_nav with IDs ending in '_trigger'.
  // On click, these listeners check and close the left menu if it's opened.
  const triggers = document.querySelectorAll("#easy_servicebar_nav [id$='_trigger']");
  triggers.forEach(trigger => {
    trigger.addEventListener("click", function () {
      if ($("body").hasClass("left-menu-opened")) {
        document.querySelector("#top-menu-rich-more").click();
      }
    });
  });
});
